import React, { useState, useEffect } from 'react'

import { getBaseUrl } from '../../Utils'
import {
    useGetBusinessParameterMutation,
    useDeleteBusinessParameterMutation,
} from '../../Redux/Admin_Tasks/BusinessParameterSlice'
import Dialog from '../../GenericComponents/dialog'
import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useTitleContext } from "../../Hooks/useTitleContext";
import { useNavigate } from 'react-router-dom'

declare let window: any
const UnicornApp = window.unicornInstance as any
interface formDatadelete {
    deleted: string
    referenced: string
    BusinessParameterGuid: string
}
const BusinessparameterList: React.FC = () => {

    const { setTitle } = useTitleContext();
    setTitle("Business Parameters");

    const navigate = useNavigate();

    const [getBusinessParameter, { data, isLoading, isError, error }] =
        useGetBusinessParameterMutation()
    const [deleteBusinessParameter] = useDeleteBusinessParameterMutation()

    useEffect(() => {
        getBusinessParameter()
    }, [getBusinessParameter])
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [selectedGuid, setSelectedGuid] = useState<string | null>(null)

    const handleOpen = async (guid: string) => {
        setSelectedGuid(guid)
        setIsDialogOpen(true)
    }
    const handleClose = () => {
        setIsDialogOpen(false)
        setSelectedGuid(null)
    }
    const handleDelete = async () => {
        if (selectedGuid) {
            setIsDialogOpen(false)
            setSelectedGuid(null)
            try {
                const formData = {
                    deleted: 'false',
                    referenced: 'false',
                    BusinessParameterGuid: selectedGuid as string,
                }

                await deleteBusinessParameter(formData).unwrap()
                FoundationsGenericToaster(
                    'success',
                    'The business parameter has been successfully deleted.'
                )
                getBusinessParameter()
                setIsDialogOpen(false)
            } catch (error) {
                console.error('Error deleting business parameter:', error)
                FoundationsGenericToaster(
                    'error',
                    'Sorry, you cannot delete this business parameter as it is used by reports in the system.'
                )
            }
        }
    }

    const handleCancel = () => {
        setIsDialogOpen(false)
        setSelectedGuid(null)
    }
    if (data) {
        return (
            <>
                <div className="float-right margin-top-small">
                    <a
                        id="link_backto_admin_tasks"
                        className="cursor-pointer"
                        href="#AdminTasks"
                    >
                        &laquo; Back to Admin Tasks
                    </a>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="header">Manage Business Parameters</div>
                    </div>
                </div>
                <div className="float-right margin-top-small">
                    <span className="sub-info">{data.length}</span>
                    <span className="sub-info"> business parameters</span>
                    <span className="admin-menu-divider">&bull;</span>
                    <a
                        className="add-button"
                        href={`${getBaseUrl()}/ux/index.html#BusinessParameters/add`}
                        style={{ cursor: 'pointer' }}
                    >
                        <i className="icon-plus-sign"></i> Add Business Parameter
                    </a>
                </div>
                <div className="padding-bottom-medium clear-both"></div>

                <table className="admin-table">
                    <thead>
                        <tr className="admin-row-header">
                            <td>Name & Description</td>
                            <td>Scope</td>
                            <td>Data Type</td>
                            <td>Value</td>
                            <td>Valid Until</td>
                            <td>IsSecured</td>
                            <td>Details</td>
                            <td className='business-params-options-col'>Options</td>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((item: any, index: any) => (
                                <tr className="admin-row-data" key={index}>
                                    <td>
                                        {item.Name}
                                        <br />
                                        <span className="smaller sub-info">{item.Description}</span>
                                    </td>
                                    <td>{item.ScopeName}</td>
                                    <td>{item._DataType}</td>
                                    <td>{item.BPValue}</td>
                                    <td>{item.ValidUntilFormatted}</td>
                                    <td>{item.IsSecured ? 'true' : 'false'}</td>
                                    <td>
                                        <span className="smaller sub-info">Created by:</span>{' '}
                                        {item.CreatedBy}
                                        <br />
                                        <span className="smaller sub-info">Created on:</span>{' '}
                                        {item.CreatedOn}
                                        <br />
                                        <span className="smaller sub-info">
                                            Last Updated on:
                                        </span>{' '}
                                        {item.LastUpdatedOn}
                                    </td>
                                    <td>
                                        <a
                                            className="app-button"
                                            style={{ padding: '6px 15px' }}
                                            data-guid={item.Guid}
                                            onClick={() => navigate(`${getBaseUrl()}/ux/index.html#BusinessParameters/edit?${item.Guid}`)}
                                        >
                                            Edit
                                        </a>
                                        <FoundationsButton
                                            type="button"
                                            id="delete-button"
                                            buttonClasses="app-button negative"
                                            classes=""
                                            disabled={item.UsedIn}
                                            hideText={false}
                                            title={
                                                item.UsedIn
                                                    ? 'Cannot be deleted. This Business Parameter is being utilized in certain reports.'
                                                    : ''
                                            }
                                            data-guid={item.Guid}
                                            onClick={() => handleOpen(item.Guid)}
                                        >
                                            Delete
                                        </FoundationsButton>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={8}>No business parameters found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div>
                    <Dialog
                        isOpen={isDialogOpen}
                        title="Delete Business Parameter"
                        onClose={handleClose}
                        modal
                        buttons={[
                            {
                                label: 'Cancel',
                                onClick: handleCancel,
                                className: "ui-button ui-corner-all ui-widget app-button negative",
                            },
                            {
                                label: 'Delete',
                                onClick: handleDelete,
                                className: " ui-button ui-corner-all ui-widget app-button modal-footer",
                            },
                        ]}
                        width={500}
                        height={170}
                        minWidth={300}
                        minHeight={150}
                    >
                        <p style={{ padding: '16px' }}>
                            Are you sure you want to delete this business parameter?
                        </p>
                    </Dialog>
                </div>
            </>
        )
    }
}
export default BusinessparameterList
